<template>
     <div class="bg">
       <table></table>
          <div class="approve_card card" style="margin-top:150px;box-shadow: 5px 6px 19px #888888;">
              <div class="card-header text-center border-bottom">
                   <h4 class="card-title" style="color:#3190e8">解绑手机</h4>
              </div>
                <form class="p-5 m-auto">
                     <table class="table_body">
                          <tr>
                               <td>
                                   <span class="ellipsis">
                                    用户名：
                                   </span>
                                </td>
                               <td>
                                  <input type="text" class="form-control" v-model="form.username">
                               </td>
                               <td>
                                   <span class="ellipsis">
                                      密码：
                                   </span>
                                </td>
                               <td>
                                 <input type="password" class="form-control" v-model="form.password">
                               </td>
                          </tr>
                           <tr>
                               <td>
                                   <span class="ellipsis">
                                    手机号：
                                   </span>
                                </td>
                               <td>
                                <input type="text" class="form-control" v-model="form.phoneNumber">
                               </td>
                          </tr>
                          <tr> 
                                <td>
                                   <span class="ellipsis">
                                       手机验证码：
                                   </span>
                               </td>
                               <td>
                                  <input type="text" class="form-control" v-model="form.security">
                               </td>
                               <td colspan="4">
                                   <button class="btn btn-primary ellipsis ml-5" :disabled="disabled" @click.prevent="getsendMessage()">
                                        {{btnText}}
                                   </button>
                                   <!-- <img :src="imageSrc" style="width:120px;height:40px;"> -->
                                </td>
                          </tr>
                          <tr>
                                <td colspan="4" class="text-center">
                                  <button class="btn btn-primary" @click.prevent="Submit()">确定解绑</button>
                                </td>
                          </tr>
                     </table>
                </form>
          </div>
     </div>
</template>
<script>
export default {
    data(){
        return{
             //imageSrc:'',
             tokenid:'',
             //获取验证码
             disabled:false,
             interval:undefined,
             totalCount:0,
             success:false,
             form:{
                username:'',
                password:'',
                phoneNumber:'',
                security:'',
             },
        }
    },
    computed:{
        btnText(){
            return this.totalCount !==0? `${this.totalCount}秒再次获取`:"获取验证码"
        }
    },
    methods:{
        getsendMessage:async function(){
            //按钮60秒倒计时
           await this.sendMessage()//60秒倒计时过后才能调用事件
            if(this.success){
                 this.totalCount=60;
                  this.disabled=true;
                    this.interval=setInterval(()=>{
                        this.totalCount--
                        if(this.totalCount === 0){
                            clearInterval(this.interval)
                            this.disabled=false;
                        }
                    },1000);
            }

        },
         sendMessage: async function () {
                let that=this;
             await that.$http.post('Home/sendMessage2', {
              
                 username:that.form.username,
                 pwd:that.form.password,
                 phone:that.form.phoneNumber,
         
             
        }).then(response => {
        //    
        if(response.data.isok){
             that.success=true;
            //   alert("信息已发送，请注意查收")
             this.$message.success("信息已发送，请注意查收!")
        }
        else if(!response.data.isok){
              alert(response.data.message)
        }
        })
      },
      approve:async function(){
            let that=this;
          await that.$http.post('Home/submitZMRZ2', {
                 username:that.form.username,
                 pwd:that.form.password,
                 phone:that.form.phoneNumber,
                 phone_yzm:that.form.security,
             
        }).then(response => {
            //  
          if(response.data.isok){
              window.sessionStorage.clear()
             that.$router.push({path:'/'})
        }
        else if(!response.data.isok){
            alert(response.data.message)
        }
        })

      },

    Submit:async function(){
            let reg1=/^1[3|4|5|8|9][0-9]\d{4,8}$/;
          if(this.form.username==""||this.form.password==""||this.form.name==""||this.form.email==""||this.form.phoneNumber==""){
               alert("请输入完整的信息")
              return;
          }
          else if(!reg1.test(this.form.phoneNumber)){
               alert("输入的手机号码不正确")
              return;
          }
          else{
              this.approve();
          }
    },
    },
    created(){
         
    }
}
</script>
<style scoped>
      .bg{
           background-image: url('../../static/images/bg1.jpg');
           background-size: 100% 100%;
           width:100%;
           height:100vh;
           background-repeat: no-repeat;
       }
.approve_card{
    margin:0 auto;
    width:700px;
    height:500px;
    background-color:#fff;
}
.table_body{
    width:500px;
    height:300px;
    font-size:15px;
}
.ellipsis{
   white-space: nowrap;
}
</style>





// WEBPACK FOOTER //
// src/components/Unbind.vue